(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-fit-tabs"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('load', function() {
    function initTab(elem){
 
        //addEventListener on mouse click
        document.addEventListener('click', function (e) {
          triggerTab(elem, e);
        });
    }
    //if option true remove active class from added element
    function findActiveElementAndRemoveIt(elem){
        var elementList = document.querySelectorAll(elem);
        Array.prototype.forEach.call(elementList, function (e) {
            e.classList.remove('active');
        });
    }

    function triggerTab(elem, e) {
      //check is the right element clicked
      if (!e.target.matches(elem+' .t-btn')) return;
      else{
          if(!e.target.classList.contains('active')){

              //if option true remove active class from all other t-btn and t-panel 
              findActiveElementAndRemoveIt(elem+' .t-btn');
              findActiveElementAndRemoveIt(elem+' .t-panel');

              //add active class on clicked tab  
              e.target.classList.add('active');  

              setTimeout(function(){                 
                  var panel = document.querySelectorAll(elem+' .t-panel.'+e.target.dataset.name);
                  Array.prototype.forEach.call(panel, function (el) {
                      //add active class on right t-panel after 200ms because of the smooth animation  
                      el.classList.add('active');
                  });
              }, 200);
          }
      }
    }

    //activate tabs function
    initTab('.tabs');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bundle-configurator-main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["configure-keycaps-palm-pads-bundle"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function(event) {
    var checkButton = document.querySelector('#checkPrivacyPolicy');
    checkButton.addEventListener('click', function() {
      if(!$('.form-wrapper').hasClass('form-error')) {
        $('.form-wrapper').addClass('form-error');
      } 
    });
    $('#contact-privacy-policy-checkbox').change(function() {
      //console.log("pressed checkbox",this.checked);
      if(this.checked){
        $('#checkPrivacyPolicy').hide();
        $('#submitButton').removeAttr('disabled');
        $('.form-wrapper').removeClass('form-error');
      }
      else{
        $('#checkPrivacyPolicy').show();
        $('#submitButton').attr('disabled', true);
      }
    });
    
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["default-configurator-main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["defy-main-product-v2"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["defy-main-product-v3"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["defy-main-product-v5"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["defy-main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
        window.pauseAllMedia();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fixed-newsletter-cta"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function(event) {
    $( document ).ready(function() {

      var elTrigger = document.querySelectorAll('.section-vip-wrapper');
      var elAnimation = document.querySelector('.fixed-cta-vip');
      var observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if(entry.isIntersecting) {
            // console.log("In");
            // console.log('elAnimation: ', elAnimation);
            elAnimation.classList.remove('showCTA');
          } else {
            // console.log("Out");
            // console.log('elAnimation: ', elAnimation);
            elAnimation.classList.add('showCTA');
          }
        });
      });

      elTrigger.forEach((el) => observer.observe(el));

      var modalTriggerButton2;
      var modalWrapper2 = document.querySelector('.newsletter-modal');
      var switchesModal2 = document.querySelector(".newsletter-modal"); // Move this line up
      
      // console.log('Element is ready modal2 - fiesta');
      modalTriggerButton2 = document.querySelector('.open-modal-newsletter2');
      modalTriggerButton2.addEventListener("click", function(event) {
        event.preventDefault();
        switchesModal2.classList.add("in");
      });
      
      document.addEventListener('keydown', function(event) {
        // If the 'esc' key is pressed, we want to close the modal
        if (event.keyCode === 27) {
          var isModalOpen = switchesModal2.classList.contains('in');
          if (isModalOpen) {
            switchesModal2.classList.remove("in");
          }
        }
      });
      
      var closeSwitchesModal = document.querySelector(".close-newsletter-modal");
      closeSwitchesModal.addEventListener("click", function(event) {
        event.preventDefault();
        switchesModal2.classList.remove("in");
      });
      
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fixed-vip-cta"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function(event) {
    $( document ).ready(function() {

      var elTrigger = document.querySelectorAll('.section-vip-wrapper');
      var elAnimation = document.querySelector('.fixed-cta-vip');
      var observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if(entry.isIntersecting) {
            // console.log("In");
            // console.log('elAnimation: ', elAnimation);
            elAnimation.classList.remove('showCTA');
          } else {
            // console.log("Out");
            // console.log('elAnimation: ', elAnimation);
            elAnimation.classList.add('showCTA');
          }
        });
      });

      elTrigger.forEach((el) => observer.observe(el));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
window.addEventListener('load', function() {
  var mainMenu = document.querySelector(".menu-items-mobile");
  var expandBtn = document.querySelectorAll(".header__menu-expandable");

  // mobile menu expand
  expandBtn.forEach((btn) => {
    btn.addEventListener("click", (event) => {
      event.preventDefault();
      mainMenu.classList.toggle("open");
    });
  });
});
class StickyHeader extends HTMLElement {
constructor() {
super();
}

connectedCallback() {
this.header = document.getElementById('shopify-section-header');
this.headerBounds = {};
this.currentScrollTop = 0;
this.preventReveal = false;

this.internalMenu = document.querySelector('.shopify-section.position-sticky');
this.headerheight = this.header.offsetHeight;

this.onScrollHandler = this.onScroll.bind(this);
this.hideHeaderOnScrollUp = () => this.preventReveal = true;

this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.addEventListener('scroll', this.onScrollHandler, false);

this.createObserver();
}

disconnectedCallback() {
this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.removeEventListener('scroll', this.onScrollHandler);
}

createObserver() {
let observer = new IntersectionObserver((entries, observer) => {
this.headerBounds = entries[0].intersectionRect;
observer.disconnect();
});

observer.observe(this.header);
}

onScroll() {
const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
requestAnimationFrame(this.hide.bind(this));
} else if (scrollTop < this.currentScrollTop && scrollTop> this.headerBounds.bottom) {
  if (!this.preventReveal) {
  requestAnimationFrame(this.reveal.bind(this));
  } else {
  window.clearTimeout(this.isScrolling);

  this.isScrolling = setTimeout(() => {
  this.preventReveal = false;
  }, 66);

  requestAnimationFrame(this.hide.bind(this));
  }
  } else if (scrollTop <= this.headerBounds.top) { requestAnimationFrame(this.reset.bind(this)); }
    this.currentScrollTop=scrollTop; } hide() {
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky' );
      if (this.internalMenu) {
        this.internalMenu.style.top = "0px";
      }
    this.closeMenuDisclosure(); this.closeSearchModal(); } reveal() {
    this.header.classList.add('shopify-section-header-sticky', 'animate' );
    this.header.classList.remove('shopify-section-header-hidden'); 
      if (this.internalMenu) {
       this.internalMenu.style.top = this.headerheight + "px";
      }
    } reset() {
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky' , 'animate' );
      if (this.internalMenu) {
        this.internalMenu.style.top = "0px";
      }
    }
    closeMenuDisclosure() { this.disclosures=this.disclosures || this.header.querySelectorAll('details-disclosure');
    this.disclosures.forEach(disclosure=> disclosure.close());
    }

    closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    if (this.searchModal != null) {
    this.searchModal.close(false);
    }
    }
    }

    customElements.define('sticky-header', StickyHeader);
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-accessories-collection-banner"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function(event) {
    var filteredProduct = new URL(document.URL).searchParams.get("filter.p.tag");
    //console.log('URL params: ', filteredProduct);
    
    var filterRaise = document.querySelector('.nav-dygma-raise');
    var filterDefy = document.querySelector('.nav-dygma-defy');

    function setActiveFilter(activeItem) {
      if (activeItem == 'Dygma Raise') {
        filterRaise.classList.add('active');
        filterRaise.setAttribute("aria-current", "page");
        filterRaise.href = "/collections/accessories";
      }
      if (activeItem == 'Dygma Defy') {
        filterDefy.classList.add('active');
        filterDefy.setAttribute("aria-current", "page");
        filterDefy.href = "/collections/accessories";
      }
    }

    setActiveFilter(filteredProduct);
    
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-dynamic-product-v2"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-dynamic-product-v3"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-configure-defy"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-configure-raise2-v2"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-configure-raise2"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-defy-fixed-config"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-vip"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menu-landing-page"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('load', function() {
    var triggerInternalMenu = document.querySelector('.triggerInternalMenu');
    var internalMenu = document.querySelector('.internal-menu');
    triggerInternalMenu.addEventListener('click', function(event){
      event.preventDefault();
      internalMenu.classList.toggle('open');
    });
  }); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["modal-newsletter-raise"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function(event) {
    $( document ).ready(function() {
     function waitForElm(selector) {
      return new Promise(resolve => {
          if (document.querySelector(selector)) {
              return resolve(document.querySelector(selector));
          }
  
          const observer = new MutationObserver(mutations => {
              if (document.querySelector(selector)) {
                  resolve(document.querySelector(selector));
                  observer.disconnect();
              }
          });
  
          observer.observe(document.body, {
              childList: true,
              subtree: true
          });
      });
    }

      var modalTriggerButton;
      var modalWrapper = document.querySelector('.newsletter-modal');
      waitForElm('.open-modal-newsletter').then((elm) => {
          // console.log('Element is ready');
          // console.log(elm.textContent);
          modalTriggerButton = document.querySelector('.open-modal-newsletter');
          modalTriggerButton.addEventListener("click", function(event) {
            event.preventDefault();
            switchesModal.classList.add("in");
          });
          document.addEventListener('keydown', function(event) {
          // If the 'esc' key is pressed, we want to close the modal
          if (event.keyCode === 27) {
            var isModalOpen = switchesModal.classList.contains('in');
            if (isModalOpen) {
              switchesModal.classList.remove("in");
            }
          }
        });
      });
      var switchesModal = document.querySelector(".newsletter-modal");
      var closeSwitchesModal = document.querySelector(".close-newsletter-modal");
      closeSwitchesModal.addEventListener("click", function(event) {
        event.preventDefault();
        switchesModal.classList.remove("in");
      });

      // modalWrapper.addEventListener("click", function(event) {
      //   if (event.target === this) {
      //     switchesModal.classList.remove("in");
      //   }
      // });

  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-raise-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["raise-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["raise2-main-product-v2"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["raise2-main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-hero-early-access"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function(event) {
    $( document ).ready(function() {
     function waitForElm(selector) {
      return new Promise(resolve => {
          if (document.querySelector(selector)) {
              return resolve(document.querySelector(selector));
          }
  
          const observer = new MutationObserver(mutations => {
              if (document.querySelector(selector)) {
                  resolve(document.querySelector(selector));
                  observer.disconnect();
              }
          });
  
          observer.observe(document.body, {
              childList: true,
              subtree: true
          });
      });
    }

      var modalTriggerButton;
      var modalWrapper = document.querySelector('.newsletter-modal');
      waitForElm('.open-modal-newsletter').then((elm) => {
          // console.log('Element is ready');
          // console.log(elm.textContent);
          modalTriggerButton = document.querySelector('.open-modal-newsletter');
          modalTriggerButton.addEventListener("click", function(event) {
            event.preventDefault();
            // console.log('clicked!');
            switchesModal.classList.add("in");
          });
          document.addEventListener('keydown', function(event) {
          // If the 'esc' key is pressed, we want to close the modal
          if (event.keyCode === 27) {
            var isModalOpen = switchesModal.classList.contains('in');
            if (isModalOpen) {
              switchesModal.classList.remove("in");
            }
          }
        });
      });
      var switchesModal = document.querySelector(".newsletter-modal");
      var closeSwitchesModal = document.querySelector(".close-newsletter-modal");
      closeSwitchesModal.addEventListener("click", function(event) {
        event.preventDefault();
        switchesModal.classList.remove("in");
      });

      // modalWrapper.addEventListener("click", function(event) {
      //   if (event.target === this) {
      //     switchesModal.classList.remove("in");
      //   }
      // });

  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-hero-newsletter-vip"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function(event) {
    $( document ).ready(function() {
     function waitForElm(selector) {
      return new Promise(resolve => {
          if (document.querySelector(selector)) {
              return resolve(document.querySelector(selector));
          }
  
          const observer = new MutationObserver(mutations => {
              if (document.querySelector(selector)) {
                  resolve(document.querySelector(selector));
                  observer.disconnect();
              }
          });
  
          observer.observe(document.body, {
              childList: true,
              subtree: true
          });
      });
    }

      var modalTriggerButton;
      var modalWrapper = document.querySelector('.newsletter-modal');
      waitForElm('.open-modal-newsletter').then((elm) => {
          // console.log('Element is ready');
          // console.log(elm.textContent);
          modalTriggerButton = document.querySelector('.open-modal-newsletter');
          modalTriggerButton.addEventListener("click", function(event) {
            event.preventDefault();
            // console.log('clicked!');
            switchesModal.classList.add("in");
          });
          document.addEventListener('keydown', function(event) {
          // If the 'esc' key is pressed, we want to close the modal
          if (event.keyCode === 27) {
            var isModalOpen = switchesModal.classList.contains('in');
            if (isModalOpen) {
              switchesModal.classList.remove("in");
            }
          }
        });
      });
      var switchesModal = document.querySelector(".newsletter-modal");
      var closeSwitchesModal = document.querySelector(".close-newsletter-modal");
      closeSwitchesModal.addEventListener("click", function(event) {
        event.preventDefault();
        switchesModal.classList.remove("in");
      });

      // modalWrapper.addEventListener("click", function(event) {
      //   if (event.target === this) {
      //     switchesModal.classList.remove("in");
      //   }
      // });

  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-hero-software"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function(event) {
  
  var observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if(entry.isIntersecting) {
        entry.target.style.transform = "perspective(400px) rotateX(7deg)"
      } else {
        entry.target.style.transform = "perspective(400px) rotateX(0deg)"
      }
    });
  });

  var elAnimation = document.querySelectorAll('#set-video-animation video');
  elAnimation.forEach((el) => observer.observe(el));

})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-hero-vip"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function(event) {
    $( document ).ready(function() {
     function waitForElm(selector) {
      return new Promise(resolve => {
          if (document.querySelector(selector)) {
              return resolve(document.querySelector(selector));
          }
  
          const observer = new MutationObserver(mutations => {
              if (document.querySelector(selector)) {
                  resolve(document.querySelector(selector));
                  observer.disconnect();
              }
          });
  
          observer.observe(document.body, {
              childList: true,
              subtree: true
          });
      });
    }

      var modalTriggerButton;
      var modalWrapper = document.querySelector('.newsletter-modal');
      waitForElm('.open-modal-newsletter').then((elm) => {
          // console.log('Element is ready');
          // console.log(elm.textContent);
          modalTriggerButton = document.querySelector('.open-modal-newsletter');
          modalTriggerButton.addEventListener("click", function(event) {
            event.preventDefault();
            // console.log('clicked!');
            switchesModal.classList.add("in");
          });
          document.addEventListener('keydown', function(event) {
          // If the 'esc' key is pressed, we want to close the modal
          if (event.keyCode === 27) {
            var isModalOpen = switchesModal.classList.contains('in');
            if (isModalOpen) {
              switchesModal.classList.remove("in");
            }
          }
        });
      });
      var switchesModal = document.querySelector(".newsletter-modal");
      var closeSwitchesModal = document.querySelector(".close-newsletter-modal");
      closeSwitchesModal.addEventListener("click", function(event) {
        event.preventDefault();
        switchesModal.classList.remove("in");
      });

      // modalWrapper.addEventListener("click", function(event) {
      //   if (event.target === this) {
      //     switchesModal.classList.remove("in");
      //   }
      // });

  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-lasts-posts"] && !Shopify.designMode) return;
  try {
    
    window.addEventListener("load", (event) => {

     $(document).ready(function () {
      
      var actualBlog = $('.actualBlog').attr('data-blog');
      //console.log('actualBlog', actualBlog);
      
      $('.collapse-tab').each(function() {
        if($(this).attr('data-category') == actualBlog) {
          $(this).addClass('active');
          $(this).addClass('animRight');
          $(this).show();
          //console.log('active tab: ', $(this));
        } else {
          $(this).removeClass('active');
          $(this).hide();
          //console.log('inactive tab: ', $(this));
        }
      });


     $('.collapse-content').removeClass('loading');
       
      $('.trigger-collapse').on('click', function(event) {
        event.preventDefault();
        if (!$(this).hasClass('active')) {
          $('.trigger-collapse').removeClass('active');
          $(this).addClass('active');
          
          
          var actualTabEl = '.collapse-tab.' + $(this).attr('data-tab');
          var actualTab = $(this).attr('data-tab');

          $('.collapse-tab').each(function() {
            if($(this).attr('data-category') == actualTab) {
              $(this).addClass('active');
              $(this).addClass('animRight');
              $(this).show();

            } else {
              $(this).removeClass('active');
              $(this).removeClass('animRight');
              $(this).hide();
            }
          });
          
           $(actualTabEl).show();
    
          //console.log('Actual tab: ', actualTab);
        }
        
      });

    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-pimp-your-keyboard"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('load', function() {
    var swiper = new Swiper("#swiper-pimp", {
      cssMode: true,
      speed: 1000,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      //wrapperClass: "snapslider-scroll",
      //slideClass: "snapslider-card",
      slidesPerView: "auto",
      mousewheel: true,
      keyboard: true,
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-remap-keys-coding"] && !Shopify.designMode) return;
  try {
    
  //window.addEventListener('load', function() {
  document.addEventListener('DOMContentLoaded', function(event) {
    $( document ).ready(function() {
      function setDropdown(actual) {
        $('.dropdown-item').each(function() {
          var pointerIndex = parseInt($(this).attr('data-dropdown-index'));
          if(actual == pointerIndex) {
            $(this).addClass('active');
            $('.dropdown-toggle .dropdown-counter span').text(actual);
            var elementActive = `.dropdown-item[data-dropdown-index="${actual}"] .dropdown-element--item`;
            $('.dropdown-toggle .dropdown-element--item').text($(elementActive).text());

            $('.dropdown-button .dropdown-toggle').removeClass('show');
            $('.dropdown-button .dropdown-menu').removeClass('show');
          } else {
            $(this).removeClass('active');
          }
        });
        console.log('.layer-base');
        $('.raise-layers .layer-base').each(function(i) {
          var pointerIndex = parseInt($(this).attr('data-layer'));
          var lastItem = $('.raise-layers .layer-base').length;
          if(actual == pointerIndex) {
            $(this).addClass('active');
          } else {
            $(this).removeClass('active');
          }
          console.log('itens ', i, lastItem);
          if (i+1 === lastItem) {
            console.log('last item');
            $('.raise-layers').addClass('in');
            setTimeout(function(){
              $('.raise-layers').removeClass('in');
            }, 400);
          }
        });
        
      }

      //$('.dropdown-toggle').on('click', function() {
      //  $('.dropdown-button .dropdown-toggle').toggleClass('show');
      //  $('.dropdown-button .dropdown-menu').toggleClass('show');
      //});
    
      $('.dropdown-item').on('click', function(event) {
        event.preventDefault();
        console.log('click');
        var setActive = parseInt($(this).attr('data-dropdown-index'));
        setDropdown(setActive);
      });

      $('.goToLayer1').on('click', function() {
        console.log('click1');
        event.preventDefault();
        setDropdown(1);
      });
      $('.goToLayer2').on('click', function() {
        event.preventDefault();
        setDropdown(2);
      });
      $('.goToLayer3').on('click', function() {
        event.preventDefault();
        setDropdown(3);
      });
      
      $('.loading').addClass('loaded');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-remap-keys-gaming"] && !Shopify.designMode) return;
  try {
    
  //window.addEventListener('load', function() {
  document.addEventListener('DOMContentLoaded', function(event) {
    $( document ).ready(function() {
      
      function setDropdown(actual) {
        $('.dropdown-item').each(function() {
          var pointerIndex = parseInt($(this).attr('data-dropdown-index'));
          if(actual == pointerIndex) {
            $(this).addClass('active');
            $('.dropdown-toggle .dropdown-counter span').text(actual);
            var elementActive = `.dropdown-item[data-dropdown-index="${actual}"] .dropdown-element--item`;
            $('.dropdown-toggle .dropdown-element--item').text($(elementActive).text());

            $('.dropdown-button .dropdown-toggle').removeClass('show');
            $('.dropdown-button .dropdown-menu').removeClass('show');
          } else {
            $(this).removeClass('active');
          }
        });
        console.log('.layer-base');
        $('.raise-layers .layer-base').each(function(i) {
          var pointerIndex = parseInt($(this).attr('data-layer'));
          var lastItem = $('.raise-layers .layer-base').length;
          if(actual == pointerIndex) {
            $(this).addClass('active');
          } else {
            $(this).removeClass('active');
          }
          console.log('itens ', i, lastItem);
          if (i+1 === lastItem) {
            // console.log('last item');
            $('.raise-layers').addClass('in');
            setTimeout(function(){
              $('.raise-layers').removeClass('in');
            }, 400);
          }
        });
        
      }

      //$('.dropdown-toggle').on('click', function() {
      //  $('.dropdown-button .dropdown-toggle').toggleClass('show');
      //  $('.dropdown-button .dropdown-menu').toggleClass('show');
      //});
    
      $('.dropdown-item').on('click', function(event) {
        event.preventDefault();
        // console.log('click');
        var setActive = parseInt($(this).attr('data-dropdown-index'));
        setDropdown(setActive);
      });

      $('#goToLayer1').on('click', function() {
        event.preventDefault();
        console.log('click layer 1');
        setDropdown(1);
      });
      
      $('#goToLayer2').on('click', function() {
        event.preventDefault();
        // console.log('click layer 2');
        setDropdown(2);
      });
      
      $('.loading').addClass('loaded');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-remap-keys-macro"] && !Shopify.designMode) return;
  try {
    
  //window.addEventListener('load', function() {
  document.addEventListener('DOMContentLoaded', function(event) {
    $( document ).ready(function() {
      
      function setDropdown(actual) {
        $('.layer-tab-item').each(function() {
          $(this).removeClass("active");
        });
        var elementTabActive = `.layer-tab-item[data-layer="${actual}"]`;
        $(elementTabActive).addClass("active");
        $('.dropdown-item').each(function() {
          var pointerIndex = parseInt($(this).attr('data-dropdown-index'));
          if(actual == pointerIndex) {
            $(this).addClass('active');
            $('.dropdown-toggle .dropdown-counter span').text(actual);
            var elementActive = `.dropdown-item[data-dropdown-index="${actual}"] .dropdown-element--item`;
            $('.dropdown-toggle .dropdown-element--item').text($(elementActive).text());

            $('.dropdown-button .dropdown-toggle').removeClass('show');
            $('.dropdown-button .dropdown-menu').removeClass('show');
          } else {
            $(this).removeClass('active');
          }
        });
        console.log('.layer-base');
        $('.raise-layers .layer-base').each(function(i) {
          var pointerIndex = parseInt($(this).attr('data-layer'));
          var lastItem = $('.raise-layers .layer-base').length;
          if(actual == pointerIndex) {
            $(this).addClass('active');
          } else {
            $(this).removeClass('active');
          }
          console.log('itens ', i, lastItem);
          if (i+1 === lastItem) {
            // console.log('last item');
            $('.raise-layers').addClass('in');
            setTimeout(function(){
              $('.raise-layers').removeClass('in');
            }, 400);
          }
        });
        
      }

      //$('.dropdown-toggle').on('click', function() {
      //  $('.dropdown-button .dropdown-toggle').toggleClass('show');
      //  $('.dropdown-button .dropdown-menu').toggleClass('show');
      //});
    
      $('.dropdown-item').on('click', function(event) {
        event.preventDefault();
        // console.log('click');
        var setActive = parseInt($(this).attr('data-dropdown-index'));
        setDropdown(setActive);
      });

      $('#goToLayer1').on('click', function() {
        event.preventDefault();
        console.log('click layer 1');
        setDropdown(1);
      });
      
      $('#goToLayer2').on('click', function() {
        event.preventDefault();
        // console.log('click layer 2');
        setDropdown(2);
      });

      $('#goToLayer3').on('click', function() {
        event.preventDefault();
        // console.log('click layer 2');
        setDropdown(3);
      });


      $('.layer-tab-item').on('click', function() {
        event.preventDefault();
        console.log('click tab');
        var setNumberActive = $(this).attr("data-layer");
        console.log('setNumberActive: ', setNumberActive);
        setDropdown(parseInt(setNumberActive));
      });
      $('.loading').addClass('loaded');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-remap-keys"] && !Shopify.designMode) return;
  try {
    
  //window.addEventListener('load', function() {
  document.addEventListener('DOMContentLoaded', function(event) {
    $( document ).ready(function() {
      function setDropdown(actual) {
        $('.dropdown-item').each(function() {
          var pointerIndex = parseInt($(this).attr('data-dropdown-index'));
          if(actual == pointerIndex) {
            $(this).addClass('active');
            $('.dropdown-toggle .dropdown-counter span').text(actual);
            var elementActive = `.dropdown-item[data-dropdown-index="${actual}"] .dropdown-element--item`;
            $('.dropdown-toggle .dropdown-element--item').text($(elementActive).text());

            $('.dropdown-button .dropdown-toggle').removeClass('show');
            $('.dropdown-button .dropdown-menu').removeClass('show');
          } else {
            $(this).removeClass('active');
          }
        });
        console.log('.layer-base');
        $('.raise-layers .layer-base').each(function(i) {
          var pointerIndex = parseInt($(this).attr('data-layer'));
          var lastItem = $('.raise-layers .layer-base').length;
          if(actual == pointerIndex) {
            $(this).addClass('active');
          } else {
            $(this).removeClass('active');
          }
          console.log('itens ', i, lastItem);
          if (i+1 === lastItem) {
            console.log('last item');
            $('.raise-layers').addClass('in');
            setTimeout(function(){
              $('.raise-layers').removeClass('in');
            }, 400);
          }
        });
        
      }

      //$('.dropdown-toggle').on('click', function() {
      //  $('.dropdown-button .dropdown-toggle').toggleClass('show');
      //  $('.dropdown-button .dropdown-menu').toggleClass('show');
      //});
    
      $('.dropdown-item').on('click', function(event) {
        event.preventDefault();
        console.log('click');
        var setActive = parseInt($(this).attr('data-dropdown-index'));
        setDropdown(setActive);
      });

      
      $('#base_82_').on('click', function() {
        event.preventDefault();
        setDropdown(1);
      });
      $('#base_60_').on('click', function() {
        event.preventDefault();
        setDropdown(1);
      });
      
      $('#base_6_').on('click', function() {
        event.preventDefault();
        setDropdown(2);
      });
      
      $('#base_77_').on('click', function() {
        event.preventDefault();
        setDropdown(2);
      });
      $('#base_7_').on('click', function() {
        event.preventDefault();
        setDropdown(3);
      });
      $('#base_35_').on('click', function() {
        event.preventDefault();
        setDropdown(3);
      });

      // Defy
      $('.goToLayer1').on('click', function() {
        console.log('click1');
        event.preventDefault();
        setDropdown(1);
      });
      $('.goToLayer2').on('click', function() {
        event.preventDefault();
        setDropdown(2);
      });
      $('.goToLayer3').on('click', function() {
        event.preventDefault();
        setDropdown(3);
      });
      
      $('.loading').addClass('loaded');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-reviews-articles"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('load', function() {
    var swiperReviews = new Swiper(".swiper-reviews", {
      speed: 500,
      // centeredSlides: true,
      // loop: true,
      // loopPreventsSlide: false,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      slidesPerView: "auto",
      mousewheel: false,
      keyboard: true,
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-user-testimonials"] && !Shopify.designMode) return;
  try {
    
//window.addEventListener('load', function() {
  document.addEventListener('DOMContentLoaded', function(event) {
    $( document ).ready(function() {
    
    var slidersCollection = document.querySelectorAll('.ezd-snapslider');

    slidersCollection.forEach((item, index) => {
      if (index != 0) {
        //console.log(index);
        item.style.display = "none";
      }
      var sliderElement = item.querySelector('.snapslider-overflow');
      var swiper = new Swiper(sliderElement, {
        cssMode: true,
        speed: 1000,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        autoplay: {
           delay: 5000,
          disableOnInteraction: true,
          pauseOnMouseEnter: true,
         },
        //wrapperClass: "snapslider-scroll",
        //slideClass: "snapslider-card",
        slidesPerView: "auto",
        mousewheel: true,
        keyboard: true,
      });
    });

    $('.sliders-loading').hide('fast');
    $('.sliders-wrapper').show('fast');


    $('.trigger-collapse').on('click', function(event) {
      event.preventDefault();
      //console.log('click');
      if (!$(this).hasClass('active')) {
        $('.trigger-collapse').removeClass('active');
        $(this).addClass('active');
        
        
        var actualTabEl = '.ezd-snapslider#' + $(this).attr('data-tab');
        var actualTab = $(this).attr('data-tab');

        $('.ezd-snapslider').each(function() {
          if($(this).attr('id') == actualTab) {
            $(this).addClass('active');
            $(this).addClass('animRight');
            $(this).show();
          } else {
            $(this).removeClass('active');
            $(this).removeClass('animRight');
            $(this).hide();
          }
        });
        
         //$(actualTabEl).show();
      }
      
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-video-carousel"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('load', function() {
    $( document ).ready(function() {
      var CARDS = 5;
      var MAX_VISIBILITY = 3;

      var timer;
      var innerVideos = document.querySelectorAll('.mobile-carousel-video');

      function setVideosOnMobile() {
        var windowWidth = window.innerWidth;
        if (windowWidth < 1000) {
          innerVideos.forEach(function(item, index) {
             if(!item.classList.contains('video-mounted')) {
                item.classList.add('video-mounted');
                var newVideo = document.createElement('video');
                newVideo.setAttribute('src', item.dataset.video);
                newVideo.setAttribute('playsinline', 'playsinline');
                newVideo.setAttribute('autoplay', 'autoplay');
                newVideo.setAttribute('loop', 'loop');
                newVideo.setAttribute('muted', 'muted');
                item.appendChild(newVideo);
                newVideo.currentTime = 0;
                newVideo.pause();
            }
          });
        }
      }
      setVideosOnMobile();

      function setCarouselVideoAutoplay(actual, duration) {
        var nextVideo = (actual < CARDS - 1) ? actual+1 : 0;
        timer = setTimeout(function() {
          setVideoActive(nextVideo);
        }, duration);
      }

      function setVideoActive(actual) {
        var windowWidth = window.innerWidth;
        $('.carousel-videos').each(function(i) {

          var videoElement = `.carousel-videos[data-carousel-index="${i+1}"] video`;
          var controlItemVideo = document.querySelector(videoElement);
          controlItemVideo.currentTime = 2;
          controlItemVideo.pause();

          var elementLink = `.carousel-videos-item[data-carousel-index=${i+1}]`;

          if (windowWidth < 881) {
            $('.carousel-videos-container').hide();
            var videoMobileWrapper = `.mobile-carousel-video[data-mobile-video="${i+1}"]`;
            var videoMobileDiv = document.querySelector(videoMobileWrapper);
            var videoMobile = videoMobileDiv.querySelector('video');
            
            videoMobile.currentTime = 0;
            videoMobile.pause();
          } else {
            $('.carousel-videos-container').show();
          }

          $(this).css({
            "--actuive" : i === actual ? 1 : 0,
            "--offset" : (actual - i) / 3,
            "--direction" : Math.sign(actual - i),
            "--abs-offset" : Math.abs(actual - i) / 3,
            "opacity" : Math.abs(actual - i) >= MAX_VISIBILITY ? 0 : 1
            //"visibility" : Math.abs(actual - i) >= MAX_VISIBILITY ? "hidden" : "visible"
          });
          if (i === actual) {
            $(elementLink).addClass('active');
            $(elementLink).css({
              "--animation-duration" : parseInt(controlItemVideo.duration) * 1000+"ms",
              "--animation-width" : "100%"
            });
            if (videoMobile) {
              $(videoMobileWrapper).show('fast');
              
              videoMobile.play();
            }
            controlItemVideo.currentTime = 0;
            controlItemVideo.play();
            $(this).addClass('active');
            clearTimeout(timer);
            setCarouselVideoAutoplay(actual, parseInt(controlItemVideo.duration) * 1000);
          } else {
            
            $(this).removeClass('active');
            $(elementLink).removeClass('active');
            $(elementLink).css({
              "--animation-duration" : "300ms",
              "--animation-width" : "0%"
            });
            if (videoMobile) {
              $(videoMobileWrapper).hide('fast');
            }
          } 
          
        });
      }

      $('.carousel-videos-item').on('click', function(e) {
        e.preventDefault();
        var setActual = parseInt($(this).attr('data-video')) - 1;
        setVideoActive(setActual);
      });

     setVideoActive(0);

      window.addEventListener("resize", setVideosOnMobile);
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sonsei-main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["switch-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
